import { atom } from 'jotai';
import { ALL_TRAFFIC } from '@src/utils/filter';
import {
  findDimensionDetailsInFilter,
  getFilterModeFromDimensionTypes,
} from '@src/utils/filter/getDimensionTypesFromFilter';
import { isAppModule, CURRENT_PRODUCT_MODE } from '@src/utils/constants';
import { METRICS_TYPES_EXCLUDE_BY_FILTER } from '@utils/metrics';
import metricsStore from '@globalStore/metricsStore';
import { derivedDimensionsMetaStore } from '@globalStore/dimensionsStore';

export const globalFilterAtom = atom(ALL_TRAFFIC);
export const contextTypeAtom = atom(CURRENT_PRODUCT_MODE);

export const pageAtom = atom((get) => {
  return {
    globalFilter: get(globalFilterAtom),
    contextType: get(contextTypeAtom),
  };
});

export const filterModeAtom = atom((get) => {
  const appliedFilter = get(globalFilterAtom);
  const { dimensionByTypes } = derivedDimensionsMetaStore.getState();
  const { dimensionTypes } = findDimensionDetailsInFilter(appliedFilter.rule, dimensionByTypes);
  const filterMode = getFilterModeFromDimensionTypes(dimensionTypes);
  return filterMode;
});

/*
For EI, filterdMetrics here, will be all EI metrics if applied filter has ad dimensions.
For AI, there are no such mapping done.
For APP, filteredMetrics is calculated based on the filter and mapping done in utils/metricList
*/
export const filterNAMetricsAtom = atom((get) => {
  const appliedFilter = get(globalFilterAtom);
  const { combinedMetricsMeta } = metricsStore.getState();
  const { dimensionByTypes } = derivedDimensionsMetaStore.getState();
  const { dimensionTypes } = findDimensionDetailsInFilter(appliedFilter.rule, dimensionByTypes);
  let excludedMetricTypes: string[] = [];
  if (isAppModule) {
    dimensionTypes.forEach((tag) => {
      excludedMetricTypes = [...excludedMetricTypes, ...METRICS_TYPES_EXCLUDE_BY_FILTER[tag]];
    });
  }
  const uniqueExcludeMetricTypes = [...new Set(excludedMetricTypes)];
  const typeGroupedMetrics = {};
  const currentMetricsMeta = combinedMetricsMeta[CURRENT_PRODUCT_MODE.toLowerCase()];
  // metricList not initialized in initial state to avoid errors or`ed with empty object
  Object.keys(currentMetricsMeta).forEach((metric: any) => {
    typeGroupedMetrics[currentMetricsMeta[metric].name] = currentMetricsMeta[metric].type;
  });
  const filteredMetrics = Object.keys(currentMetricsMeta).filter((metric) => {
    const metricType = typeGroupedMetrics[metric];
    return uniqueExcludeMetricTypes.includes(metricType);
  });
  return filteredMetrics;
});
